import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { marcaAdapter } from "@/data";
import { toast } from "@/hooks/use-toast";
import type { Marca } from "@/types/marca";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  item: Marca | null;
  onSuccess: () => void;
}

export function MarcaDeleteDialog({ open, onOpenChange, item, onSuccess }: Props) {
  const handleConfirm = async () => {
    if (!item || item.sistema) return;
    try {
      await marcaAdapter.delete(item.id_marca);
      toast({ title: "Sucesso", description: "Marca excluída com sucesso!" });
      onSuccess();
      onOpenChange(false);
    } catch (error) {
      toast({ title: "Erro", description: "Não foi possível excluir.", variant: "destructive" });
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir Marca</AlertDialogTitle>
          <AlertDialogDescription>
            {item?.sistema ? "Marcas de sistema não podem ser excluídas." : `Tem certeza que deseja excluir permanentemente "${item?.nome}"? Esta ação não pode ser desfeita.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} disabled={item?.sistema}>Excluir</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
